import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { client } from "@/main";
import { useProjectStore } from "@/store/modules/project";
export const useEndpointsStore = defineStore("endpoints", () => {
    const detail = ref({});
    const isLoading = ref(false);
    const mqttGatewaysResponse = ref({ data: [], count: 0 });
    const allEndpoints = ref([]);
    const allEndpointsCount = ref(0);
    const allEndpointsForReal = computed(() => [
        ...allEndpoints.value,
        ...mqttGatewaysResponse.value.data
    ]);
    async function getEndpoint(endpointId, isFullDetail = false) {
        isLoading.value = true;
        const { data } = await client.path("/http/endpoints/{id}").method("get").create()({
            id: String(endpointId),
            fullDetail: isFullDetail || undefined
        });
        detail.value = data.data ?? {};
        isLoading.value = false;
    }
    async function assignToDataFlow(dataFlowId, endpointId) {
        const { data } = await client.path("/device-groups/{id}/endpoints/{endpointId}/assign").method("post").create()({
            id: dataFlowId,
            endpointId
        });
        return data?.status === "success";
    }
    async function getMqttGateways(getParams) {
        const projectStore = useProjectStore();
        if (!projectStore.selectedProject)
            return [];
        const { data } = await client.path("/mqtt/gateways").method("get").create()({
            "projectId[eq]": projectStore.selectedProject.projectId,
            limit: getParams.rowsPerPage || 1000,
            offset: getParams.currentPage * getParams.rowsPerPage || 0,
            sort: getParams.sort || undefined
        });
        const mappedData = (data.data ?? []).map((mg) => ({ ...mg, protocol: "MQTT", protocolLabel: "MQTT" }));
        mqttGatewaysResponse.value = { data: mappedData, count: data.metadata?.count ?? 0 };
        return true;
    }
    async function getAllEndpoints(getParams) {
        const projectStore = useProjectStore();
        if (!projectStore.selectedProject)
            return [];
        const { data } = await client.path("/http/endpoints").method("get").create()({
            "projectId[eq]": projectStore.selectedProject.projectId,
            sort: getParams.sort,
            limit: getParams.rowsPerPage || 1000,
            offset: getParams.currentPage * getParams.rowsPerPage || 0
        });
        allEndpointsCount.value = data.metadata?.count ?? 0;
        allEndpoints.value = (data.data ?? []).map((ep) => ({ ...ep, protocol: "HTTP", protocolLabel: "REST" }));
        return true;
    }
    return {
        detail,
        isLoading,
        mqttGatewaysResponse,
        allEndpoints,
        allEndpointsCount,
        allEndpointsForReal,
        getEndpoint,
        assignToDataFlow,
        getMqttGateways,
        getAllEndpoints
    };
});
